import React, { useState, useEffect } from 'react';
import API from '../../api/axios';
import { formatCreatedAt } from '../../utils/dateUtils';

const PaymentHistory = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
  const [statusFilter, setStatusFilter] = useState('');

  const fetchPayments = async (page = 1, status = '') => {
    setLoading(true);
    try {
      const params = { page, limit: 10 };
      if (status) params.status = status;
      const res = await API.get('/payments/my-payments', { params });
      setPayments(res.data.data.payments);
      setPagination({
        page: res.data.data.pagination.page,
        totalPages: res.data.data.pagination.totalPages,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments(1, statusFilter);
  }, [statusFilter]);

  const getStatusBadge = (status) => {
    const map = {
      initiated: 'Initié', pending: 'En cours', success: 'Réussi',
      failed: 'Échoué', cancelled: 'Annulé',
    };
    return <span className={`badge badge-${status}`}>{map[status] || status}</span>;
  };

  const providerNames = {
    mpesa: 'M-Pesa', orange_money: 'Orange Money',
    airtel_money: 'Airtel Money', afrimoney: 'Afrimoney',
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 600 }}>Historique des paiements</h2>
          <p style={{ color: 'var(--gray-500)', fontSize: 14 }}>Tous vos paiements Mobile Money</p>
        </div>
        <select
          className="form-select"
          style={{ width: 180 }}
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="">Tous les statuts</option>
          <option value="success">Réussi</option>
          <option value="pending">En cours</option>
          <option value="failed">Échoué</option>
          <option value="initiated">Initié</option>
        </select>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading-page"><div className="spinner"></div></div>
        ) : payments.length === 0 ? (
          <div className="empty-state">
            <h3>Aucun paiement</h3>
            <p>Vous n'avez pas encore effectué de paiement.</p>
          </div>
        ) : (
          <>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Référence</th>
                    <th>Facture</th>
                    <th>Montant</th>
                    <th>Opérateur</th>
                    <th>Téléphone</th>
                    <th>Statut</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((p) => (
                    <tr key={p.id}>
                      <td style={{ fontWeight: 600, fontSize: 13 }}>{p.payment_reference}</td>
                      <td>
                        <span style={{ fontSize: 13 }}>{p.invoice?.invoice_number}</span>
                        <br />
                        <span style={{ fontSize: 12, color: 'var(--gray-500)' }}>{p.invoice?.motif}</span>
                      </td>
                      <td style={{ fontWeight: 600 }}>{parseFloat(p.amount).toLocaleString()} {p.currency}</td>
                      <td>{providerNames[p.provider] || p.provider}</td>
                      <td>{p.phone_number}</td>
                      <td>{getStatusBadge(p.status)}</td>
                      <td>{formatCreatedAt(p)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {pagination.totalPages > 1 && (
              <div className="pagination">
                <button disabled={pagination.page <= 1} onClick={() => fetchPayments(pagination.page - 1, statusFilter)}>
                  Précédent
                </button>
                <span style={{ fontSize: 14, color: 'var(--gray-600)' }}>
                  Page {pagination.page} / {pagination.totalPages}
                </span>
                <button disabled={pagination.page >= pagination.totalPages} onClick={() => fetchPayments(pagination.page + 1, statusFilter)}>
                  Suivant
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentHistory;
